import { c as _c } from "react-compiler-runtime";
import { Route, Switch } from 'quartz-routing/react-router';
import { SharePage } from './SharePage';
import { ExpiredOrInvalidPage } from './ExpiredOrInvalidPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Routes() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/:accessToken",
        component: SharePage
      }), /*#__PURE__*/_jsx(Route, {
        component: ExpiredOrInvalidPage
      })]
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}